import React from "react";
import { ComponentType } from "@growth-machine-llc/stridist-api-client";
import ComponentTemplateLibrary from "../../../../components/component-templates-library/ComponentTemplateLibrary";
import { SidebarProvider } from "../../../../contexts/CurriculumSidebarContext";
import { TemplateSidebarProvider } from "../../../../contexts/TemplateSidebarContext";
import { EnableColorsContext } from "../../../../hooks/useEnableColors";
import { ComponentTemplateDialogProvider } from "../../../../contexts/TemplateDialogContext";

export const CoachTemplateLibraryList = ({ type }: { type: ComponentType }) => {
  return (
    <TemplateSidebarProvider>
      <EnableColorsContext.Provider value={true}>
        <ComponentTemplateDialogProvider>
          <ComponentTemplateLibrary componentType={type} />
        </ComponentTemplateDialogProvider>
      </EnableColorsContext.Provider>
    </TemplateSidebarProvider>
  );
};
